import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppMaterialModule } from './app-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMenuComponent } from './components/menu/menu.component';
import { Object3dTreeComponent } from './components/object3d-tree/object3d-tree.component';
import { Object3dEditorComponent } from './components/object3d-editor/object3d-editor.component';
import { Visualize3dModule } from '../../../visualize3d/src/public-api';
import { environment } from '../environments/environment';
import { TransformComponentEditorComponent } from './components/transform-component-editor/transform-component-editor.component';
import { QModelComponentEditorComponent } from './components/q-model-component-editor/q-model-component-editor.component';
import { UnknownComponentEditorComponent } from './components/unknown-component-editor/unknown-component-editor.component';
import { PreferencesDialogComponent } from './components/preferences-dialog/preferences-dialog.component';
import { AboutDialogComponent } from './components/about-dialog/about-dialog.component';
import { AmbientLightEditorComponent } from './components/ambient-light-editor/ambient-light-editor.component';
import { SpotLightEditorComponent } from './components/spot-light-editor/spot-light-editor.component';
import { FormParser } from './providers/form-parser.service';

@NgModule({
  declarations: [
    AppComponent,
    AppMenuComponent,
    Object3dTreeComponent,
    Object3dEditorComponent,
    TransformComponentEditorComponent,
    QModelComponentEditorComponent,
    UnknownComponentEditorComponent,
    PreferencesDialogComponent,
    AboutDialogComponent,
    AmbientLightEditorComponent,
    SpotLightEditorComponent,
  ],
  imports: [
    AppMaterialModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    Visualize3dModule.forRoot(environment.apiRoot, environment.throwOnQpdErrors),
  ],
  providers: [FormParser],
  bootstrap: [AppComponent],
})
export class AppModule {}
